import React, { useContext } from 'react'
import LabeledInputField from '../utils/custom-fields'
import { useForm } from 'react-hook-form'
// import { useForm } from 'react-hook-form/dist/index.ie11.development'
import { useActions } from '../Action'
import { store } from '../Store'
import { useHistory } from 'react-router-dom'

import vodaLogo from '../assets/img-vodafone.png'
import vodaBanner from '../assets/Banner.png'

const changePassword = () => {
  const { state, dispatch } = useContext(store)
  const actions = useActions(state, dispatch)
  const history = useHistory()
  const { register, errors, formState } = useForm({
    mode: 'onChange',
    defaultValues: {},
  })
  const { isValid } = formState
  const { Login, forgotPasswordSuccessResponse, confirmPasswordError  } = state
  const status = forgotPasswordSuccessResponse && forgotPasswordSuccessResponse.Status
  const confirmPassStatus = confirmPasswordError && confirmPasswordError.Status
  const confirmPassFailureMsg  =  confirmPassStatus ? confirmPasswordError && confirmPasswordError.Error : ''
  const resources = state && state.resources
  const invalidPassword = Login && Login.invalidPassword
  const newPassword = Login && Login.newPassword
  const currentPassword = Login && Login.currentPassword
  const confirmNewPassword = Login && Login.confirmNewPassword
  const passwordStatus = Login && Login.Status
  const CognitoError = Login && Login.CognitoError
  const isSubmitted = state && state.isSubmitted
  const verificationCode = Login && Login.verificationCode
  let ErrorMessage = ''
  if (CognitoError && CognitoError.includes('Unable to find agent with Mail id', 0)) {
    ErrorMessage = 'Please contact your IT Administrator'
  } else {
    ErrorMessage = CognitoError
  }
  if (passwordStatus === 'success') {
    history.replace('/confirmorder')
  }
  // if (newPassword === confirmNewPassword && newPassword !== currentPassword && invalidPassword === true) {
  //   actions.setInvalidPassword(false)
  // }

  const changePassword = () => {
    // var CryptoJS = require("crypto-js");
    // var encryptedNewPassword = CryptoJS.AES.encrypt(Login && Login.newPassword, process.env.SECURITY_KEY).toString();
    
    // var encryptedCurrentPassword = CryptoJS.AES.encrypt(Login && Login.currentPassword, process.env.SECURITY_KEY).toString();

    if(status && status === 'Success'){
      const data = {
        username: Login && Login.emailId,
        verificationcode: Login && Login.verificationCode,
        newpassword: Login && Login?.newPassword,
      }
      if (newPassword === confirmNewPassword && verificationCode !== undefined ) {
        actions.confirmPassword(data)
      } else {
        actions.setInvalidPassword(true)
      }
    }else{
      const data = {
        username: Login && Login?.vodafoneAgentId,
        newpassword: Login && Login?.newPassword,
        oldpassword: Login && Login?.currentPassword,
      }
      if (newPassword === confirmNewPassword && newPassword !== currentPassword) {
        actions.changePassword(data)
      } else {
        actions.setInvalidPassword(true)
      }
    }

  }
  return (
    <div>
      <div className="">
        <img src={vodaLogo} className="mt-50 mb-30 ml-50" />
      </div>
      <div className="">
        <img src={vodaBanner} className="" />
      </div>
      <div className="mx-auto max-w-screen-lg mb-30">
        <div className="flex flex-row mt-80 justify-center">
          <div className="mr-100">
          <p className="text-24 leading-28 font-VodafoneRgBd">How to reset your password</p>
          <p className="text-26 leading-28 font-VodafoneRgBd mt-20">Password requirements</p>
          <p className="text-24 leading-28 font-VodafoneRg mt-20">At least one lower case letter [a-z]</p>
          <p className="text-24 leading-28 font-VodafoneRg ">At least one upper case letter [A-Z]</p>
          <p className="text-24 leading-28 font-VodafoneRg ">At least one numeral [0-9]</p>
          <p className="text-24 leading-28 font-VodafoneRg ">At least one symbol [@!#$%&]</p>
          <p className="text-24 leading-28 font-VodafoneRg ">Minimum of 8 characters</p>

          </div>
          <div className="flex flex-col">
            <p className="text-24 leading-28 font-VodafoneRgBd">Change your password</p>
            <div className="inline-block mt-20 flex flex-col w-300">
              { status && status === 'Success' ?
                <LabeledInputField
                name="verificationCode"
                type="text"
                labelClass="mr-10 w-150 inline-block"
                label="VODAFONE_LBL_VERFICATION_CODE"
                placeholder="VODAFONE_LBL_VERFICATION_CODE"
                className="mt-10 w-300 h-50"
                onChange={actions.setVerificationCode}
                register={register}
                errors={errors}
                schema="verification"
                defaultValue={Login && Login.verificationCode}
              /> :
              <LabeledInputField
                name="currentPassword"
                type="password"
                labelClass="mr-10 w-150 inline-block"
                label="VODAFONE_CURRENT_PASSWORD_LABEL"
                placeholder="VODAFONE_CURRENT_PASSWORD_LABEL"
                className="mt-10 w-300 h-50"
                onChange={actions.setCurrentPassword}
                register={register}
                errors={errors}
                schema="verification"
                defaultValue={Login && Login.currentPassword}
              />
            }
            </div>
            <div className="inline-block mt-20 flex flex-col w-300">
              <LabeledInputField
                name="newPassword"
                type="password"
                labelClass="mr-10 w-150 inline-block"
                label="VODAFONE_NEW_PASSWORD_LABEL"
                placeholder="VODAFONE_NEW_PASSWORD_LABEL"
                className="mt-10 w-300 h-50"
                onChange={actions.setNewPassword}
                register={register}
                errors={errors}
                schema="verification"
                defaultValue={Login && Login.newPassword}
              />
            </div>
            <div className="inline-block mt-20 flex flex-col w-300">
              <LabeledInputField
                name="confirmNewPassword"
                type="password"
                labelClass="mr-10 w-150 inline-block"
                label="VODAFONE_CONFIRM_NEW_PASSWORD_LABEL"
                placeholder="VODAFONE_CONFIRM_NEW_PASSWORD_LABEL"
                className="mt-10 w-300 h-50"
                onChange={actions.setConfirmNewPassword}
                register={register}
                errors={errors}
                schema="verification"
                defaultValue={Login && Login.confirmNewPassword}
              />
            </div>
            <div className="mt-34 mx-auto w-300">
              <button
                disabled={invalidPassword || !isValid}
                onClick={() => changePassword()}
                type="submit"
                className={`${invalidPassword || !isValid ? 'disable-button' : 'purple-button'} btn`}>
                Save Changes
                </button>
            </div>
          </div>
        </div>

        {(invalidPassword || passwordStatus === 'failure' || confirmPassStatus === 'failure' || confirmPassStatus === 'account_lock') && isSubmitted && (
          <div className="flex flex-row">
            <p className="error-text mx-auto">
              {newPassword !== confirmNewPassword
                ? 'Passwords are not matching'
                : newPassword === currentPassword
                  ? 'New password can not be same as current password'
                  : passwordStatus === 'failure'
                    ? ErrorMessage
                    :  confirmPassFailureMsg ?
                    confirmPassStatus === 'account_lock' ? "Too many failed attempts. Your account has been locked, please try again in 10 minutes." : confirmPassFailureMsg :
                    ''
                    }
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
export default changePassword